<h4>Contact History</h4>
@for (event of contactHistoryEvents; track event) {
  <div class="grid-x margin-top" [ngClass]="getEventClass(event.eventType)">
    <div class="cell small-6 padding-left">
      {{ event.timestamp | date: 'M/d/yy | h:mma' }}
    </div>
    <div class="cell small-6 text-align-right padding-right">
      {{ getEventDescription(event.eventType) }}
    </div>
  </div>
  <div class="cell text-align-left padding-left" [ngClass]="getEventClass(event.eventType)">
    {{ event.eventDetails }}
  </div>
}